/**
 * ArticleListService — fetch-based replacement for the legacy jQuery SearchService.
 *
 * Builds a Sling-style selector URL by inserting dot-separated props before
 * the file extension, e.g.:
 *   apiUrl = "/api/articles.json"
 *   propArray = ["tag.news", "results.10"]
 *   → "/api/articles.tag.news.results.10.json"
 *
 * @ticket AB-8816
 */

export interface SearchResponse {
  response: {
    docs: any[];
    numFound: number;
  };
  nextCursorMark?: string;
}

export class ArticleListService {
  private apiUrl: string;

  constructor(apiUrl: string) {
    this.apiUrl = apiUrl;
  }

  async query(propArray: string[] = []): Promise<SearchResponse> {
    const prop = propArray.filter(Boolean).join(".");
    let url: string;

    if (prop) {
      const lastDot = this.apiUrl.lastIndexOf(".");
      if (lastDot !== -1) {
        url =
          this.apiUrl.substring(0, lastDot) +
          "." +
          prop +
          this.apiUrl.substring(lastDot);
      } else {
        url = this.apiUrl + "." + prop;
      }
    } else {
      url = this.apiUrl;
    }

    const response = await fetch(url);

    if (!response.ok) {
      throw new Error(`HTTP ${response.status}: ${response.statusText}`);
    }

    return response.json();
  }
}
